//import { useEffect, useRef } from "react";
import { addLocaleData, getStrapiMedia } from "../../utils/utils";
import "./Footer.scss";
import { FooterComponent_Plain } from "../../types/components/global/FooterComponent.ts";
import { LinkComponent_Plain } from "../../types/components/shared/LinkComponent.ts";
import { useTranslation } from "react-i18next";

//const scrollPositionUpdated = new Event("scrollPositionUpdated");

const Footer = ({
  data,
  locale,
}: {
  data: FooterComponent_Plain;
  locale: string;
}) => {
  const { t } = useTranslation();
  const menuItems = (data.menu || []).map(
    (item: LinkComponent_Plain, i: number) => (
      <li key={i}>
        <a href={addLocaleData(item.link, locale)} target={item.target}>
          {item.title}
        </a>
      </li>
    ),
  );
  const menuItems2 = (data.menu2 || []).map(
    (item: LinkComponent_Plain, i: number) => (
      <li key={i}>
        <a href={addLocaleData(item.link, locale)} target={item.target}>
          {item.title}
        </a>
      </li>
    ),
  );
  const menuItems3 = (data.menu3 || []).map(
    (item: LinkComponent_Plain, i: number) => (
      <li key={i}>
        <a href={addLocaleData(item.link, locale)} target={item.target}>
          {item.title}
        </a>
      </li>
    ),
  );

  const handleScrollToTop = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer>
      <div className="footer-top">
        <div className="wrapper">
          <div className="footer-logo">
            <div className="hide-mob">
              <img
                width="139"
                height="17"
                src={getStrapiMedia(data.logo.url)}
              />
            </div>
            {data.footerText ? (
              <div className="footer-text">{data.footerText}</div>
            ) : (
              ""
            )}
          </div>
          <div className="box-btn-top">
            <a className="btn-top" onClick={handleScrollToTop}></a>
          </div>
        </div>
      </div>
      <div className="footer-center">
        <div className="wrapper">
          <div className="footer-col">
            <div className="footer-menu">
              <ul>{menuItems}</ul>
            </div>
          </div>
          <div className="footer-col">
            <div className="footer-menu">
              <ul>{menuItems2}</ul>
            </div>
          </div>
          <div className="footer-col">
            <div className="footer-menu">
              <ul>{menuItems3}</ul>
            </div>
          </div>
          <div className="footer-col footer-col_e-mail">
            <div className="email-section">
              <div className="email-item">
                <span>{t("Media")}</span>
                <br />
                {t("Email label")}:{" "}
                <a
                  className="footer-text-email"
                  href={`mailto:${t("Email media")}`}
                >
                  {t("Email media")}
                </a>
              </div>
              <div className="email-item">
                <span>{t("General inquiries")}</span>
                <br />
                {t("Email label")}:{" "}
                <a
                  className="footer-text-email"
                  href={`mailto:${t("Email info")}`}
                >
                  {t("Email info")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="wrapper">
          <div className="copy">{data.leftText}</div>
          <div className="copy-rules">{data.rightText}</div>
          <div className="copy-created">
            {t("Created by")}{" "}
            <a href="https://twid.marketing/" target="_blank">
              twid
            </a>
          </div>
        </div>
      </div>
      <div className="footer-logo show-mob">
        <img width="139" height="17" src={getStrapiMedia(data.logo.url)} />
      </div>
    </footer>
  );
};

export default Footer;
